var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Chart from "react-apexcharts";
import CardChart from "./Charts";
import { useTranslation } from "react-i18next";
import { CircularProgress, MenuItem, Select, Stack, Tooltip } from "@mui/material";
import { useNumberFormat } from "@sequentech/ui-core";
import { withEscapedChartText } from "@sequentech/ui-essentials";
import { toVotesPerDayChartData } from "./votesPerDayData";
import { getVotesPerDayChartOptions } from "./votesPerDayOptions";
import { getVotesTimeRangeOptions, isVotesTimeRange, isVotesTimeResolution, VotesTimeResolution, withVotesTimeResolution, } from "./votesTimeRange";
var compactSelectSx = {
    "height": 28,
    "fontSize": "0.75rem",
    "& .MuiSelect-select": {
        paddingTop: "3px",
        paddingBottom: "3px",
        paddingLeft: "8px",
        paddingRight: "24px !important",
    },
};
var compactMenuProps = {
    PaperProps: {
        sx: {
            "marginTop": "4px",
            "& .MuiMenuItem-root": {
                minHeight: 30,
                fontSize: "0.75rem",
            },
        },
    },
};
export var VotesPerDay = function (_a) {
    var _b;
    var data = _a.data, width = _a.width, height = _a.height, selection = _a.selection, onSelectionChange = _a.onSelectionChange;
    var _c = useTranslation(), t = _c.t, i18n = _c.i18n;
    var policy = useNumberFormat().policy;
    var rangeOptions = getVotesTimeRangeOptions(selection.resolution);
    var controls = (_jsxs(Stack, { direction: "row", spacing: 0.5, children: [_jsx(Tooltip, { title: String(t("dashboard.timeResolution")), placement: "top", children: _jsx(Select, { value: selection.resolution, size: "small", sx: __assign(__assign({}, compactSelectSx), { minWidth: 72 }), inputProps: {
                        "aria-label": String(t("dashboard.timeResolution")),
                    }, MenuProps: compactMenuProps, onChange: function (event) {
                        var resolution = event.target.value;
                        if (isVotesTimeResolution(resolution)) {
                            onSelectionChange(withVotesTimeResolution(resolution));
                        }
                    }, children: Object.values(VotesTimeResolution).map(function (resolution) { return (_jsx(MenuItem, { value: resolution, children: String(t("dashboard.".concat(resolution))) }, resolution)); }) }) }), _jsx(Tooltip, { title: String(t("dashboard.timeRange")), placement: "top", children: _jsx(Select, { value: selection.range, size: "small", sx: __assign(__assign({}, compactSelectSx), { minWidth: 58 }), inputProps: {
                        "aria-label": String(t("dashboard.timeRange")),
                    }, MenuProps: compactMenuProps, onChange: function (event) {
                        var range = event.target.value;
                        if (isVotesTimeRange(range) &&
                            rangeOptions.some(function (option) { return option.value === range; })) {
                            onSelectionChange(__assign(__assign({}, selection), { range: range }));
                        }
                    }, children: rangeOptions.map(function (_a) {
                        var value = _a.value, label = _a.label;
                        return (_jsx(MenuItem, { value: value, children: label }, value));
                    }) }) })] }));
    if (!data) {
        return (_jsx(CardChart, { title: String(t("dashboard.votesOverTime")), actions: controls, children: _jsx(CircularProgress, { size: 24 }) }));
    }
    var chartData = toVotesPerDayChartData(data);
    var state = {
        options: withEscapedChartText(getVotesPerDayChartOptions({
            buckets: chartData.buckets,
            resolution: selection.resolution,
            locale: (_b = i18n.resolvedLanguage) !== null && _b !== void 0 ? _b : i18n.language,
            numberFormatPolicy: policy,
        })),
        series: chartData.series.map(function (_a) {
            var channel = _a.channel, channelData = _a.data;
            return ({
                name: String(t("common.channel.".concat(channel.toLowerCase()))),
                data: channelData,
            });
        }),
    };
    return (_jsx(CardChart, { title: String(t("dashboard.votesOverTime")), actions: controls, children: _jsx(Chart, { options: state.options, series: state.series, type: "bar", width: width, height: height }) }));
};
